import React, { useState } from 'react';
import './ContactForm.css';

const ContactForm = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    message: '',
    company: '' // Honeypot field
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    const limits = { name: 100, email: 100, message: 1000, company: 100 };
    if (value.length > limits[name]) return;

    setFormState({ ...formState, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Honeypot check
    if (formState.company.trim() !== '') {
      setStatus('Bot submission detected.');
      return;
    }

    // Validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const namePattern = /^[A-Za-z\s]{2,100}$/;

    if (!emailPattern.test(formState.email)) {
      setStatus('Please enter a valid email address.');
      return;
    }

    if (!namePattern.test(formState.name)) {
      setStatus('Please enter a valid name (letters and spaces only).');
      return;
    }

    const response = await fetch("https://formspree.io/f/xaneapez", {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formState),
    });

    if (response.ok) {
      setStatus('Thank you! Your message has been sent.');
      setFormState({ name: '', email: '', message: '', company: '' });
    } else {
      setStatus('Oops! There was a problem.');
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <h3>Contact Me</h3>
      <input 
        type="text" 
        name="name"
        placeholder="Your Name / Organization"
        value={formState.name}
        onChange={handleChange}
        required
        maxLength={100}
      />
      <input 
        type="email" 
        name="email"
        placeholder="Your Email"
        value={formState.email}
        onChange={handleChange}
        required
        maxLength={100}
      />
      <textarea 
        name="message"
        placeholder="Your Message"
        value={formState.message}
        onChange={handleChange}
        required
        className='message-input'
        maxLength={1000}
      />
      <small style={{ textAlign: 'right', display: 'block', marginTop: '-10px', marginBottom: '10px', color: '#666' }}>
        {formState.message.length} / 1000 characters
      </small>

      {/* Honeypot field */}
      <input
        type="text"
        name="company"
        value={formState.company}
        onChange={handleChange}
        style={{ display: 'none' }}
        autoComplete="off"
      />

      <button type="submit">Send</button>
      <p className="form-status">{status}</p>
    </form>
  );
};

export default ContactForm;
